import { defineMessages, type IntlShape } from 'react-intl';

import type { JSONSchema } from '@plone/types';
import { addStyling } from '@plone/volto/helpers/Extensions/withBlockSchemaEnhancer';

const addBlockLines = ({
  schema,
  formData,
  intl,
}: {
  schema: JSONSchema;
  formData: JSONSchema;
  intl: IntlShape;
}): JSONSchema => {
  addStyling({ schema, intl, formData });

  // @ts-expect-error
  schema.properties.styles.schema.fieldsets[0].fields = [
    // @ts-expect-error
    ...schema.properties.styles.schema.fieldsets[0].fields,
    'add_top_line',
    'add_bottom_line',
    'line_color',
  ];

  // @ts-expect-error
  schema.properties.styles.schema.properties['add_top_line'] = {
    type: 'boolean',
    title: intl.formatMessage(messages.top_border_style_title),
  };

  // @ts-expect-error
  schema.properties.styles.schema.properties['add_bottom_line'] = {
    type: 'boolean',
    title: intl.formatMessage(messages.bottom_border_style_title),
  };

  // @ts-expect-error
  schema.properties.styles.schema.properties['line_color'] = {
    widget: 'color_picker',
    title: intl.formatMessage(messages.line_color_title),
    colors: [
      {
        name: 'red',
        label: 'red',
      },
      { name: 'gray', label: 'Gray' },
      {
        name: 'black',
        label: 'Black',
      },
    ],
    default: 'red',
  };

  return schema;
};

export default addBlockLines;
const messages = defineMessages({
  line_color_title: {
    id: 'line_color_title',
    defaultMessage: 'Line color',
  },
  top_border_style_title: {
    id: 'top_border_style_title',
    defaultMessage: 'Add top border line',
  },
  bottom_border_style_title: {
    id: 'bottom_border_style_title',
    defaultMessage: 'Add bottom border line',
  },
});
